import React from 'react';

import { FormControl, Box, FormHelperText, TextField } from '@mui/material';
import type { FormFieldProps } from '@/types';

export default function AccountLastNameField({
  value,
  error,
  setValue,
  setError,
}: FormFieldProps) {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value: newValue } = event.target;
    setValue(newValue);
    if (/[#^$<>+%!`&*'"|{}?/\\:=@]/.test(newValue)) {
      setError('Last name cannot contain #^$<>+%!`&*\'"|{}?/\\:=@');
    } else if (newValue === '') {
      setError('Last name cannot be blank');
    } else {
      setError(false);
    }
  };

  return (
    <Box>
      <FormControl fullWidth required>
        <TextField
          label='Last Name'
          id='last_name'
          aria-describedby='last-name-helper-text'
          onChange={handleChange}
          error={Boolean(error || value === '')}
          value={value}
          variant='standard'
          required
        />
        {error ? (
          <FormHelperText id='last-name-helper-text'>{error}</FormHelperText>
        ) : (
          <FormHelperText id='last-name-helper-text'>
            Enter your family name
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}

